import { request } from 'utils/request'

import accounts from './accounts'
import agents from './agents'
import agentsDashboard from './agentsDashboard'
import atoCampaign from './atoCampaign'
import atoCorrelationRules from './atoCorrelationRules'
import atoOverview from './atoOverview'
import atoSettings from './atoSettings'
import awarenessCenter from './awarenessCenter'
import companies from './companies'
import connectWisePSA from './connectWisePSA'
import onboardingWizard from './createOnboardingWizardApi'
import creditManagement from './creditManagement'
import dashboard from './dashboard'
import emailEncryption from './emailEncryption'
import groupSettings from './groupSettings'
import investigation from './investigation'
import login from './login'
import mailboxes from './mailboxes'
import msp from './msp'
import psaIntegrations from './psaIntegrations'
import redTeam from './redTeam'
import reports from './reports'
import resolutionCenter from './resolutionCenter'
import settings from './settings'
import spearPhishingAgent from './spearPhishingAgent'
import threatLog from './threatLog'
import vendors from './vendors'
import visualDetection from './visualDetection'
import wizardCampaign from './wizardCampaign'

export default {
  login: login(),
  accounts: accounts(request),
  agents,
  agentsDashboard,
  atoCampaign,
  atoCorrelationRules: atoCorrelationRules(),
  atoOverview: atoOverview(),
  atoSettings: atoSettings(),
  companies: companies(request),
  creditManagement,
  dashboard: dashboard(request),
  emailEncryption: emailEncryption(),
  settings: settings(request),
  msp: msp(),
  redTeam,
  reports: reports(),
  mailboxes: mailboxes(),
  visualDetection: visualDetection(),
  awarenessCenter: awarenessCenter(),
  resolutionCenter: resolutionCenter(),
  onboardingWizard: onboardingWizard(),
  psaIntegrations: psaIntegrations(),
  wizardCampaign: wizardCampaign(),
  groupSettings: groupSettings(),
  threatLog: threatLog(),
  investigation: investigation(),
  connectWisePSA: connectWisePSA(),
  spearPhishingAgent: spearPhishingAgent(),
  vendors: vendors(),
}
